import { rootRoute } from './root';
import { middleware } from './config';
import { on, off, trigger, classList } from '@acng/frontend-bounty';
export class ViewPort extends EventTarget {
    content;
    tokens = [];
}
const viewPorts = new Map;
export const getViewPort = (name) => {
    let viewPort = viewPorts.get(name);
    if (!viewPort) {
        viewPort = new ViewPort;
        viewPorts.set(name, viewPort);
    }
    return viewPort;
};
export const setViewPort = (name, content, ...tokens) => {
    const viewPort = getViewPort(name);
    viewPort.content = content;
    viewPort.tokens = tokens;
    trigger(viewPort, 'content', viewPort);
};
// TODO instead of a name it might be possible to define a target selector. other "template" middleware/module not "view"
export const view = (name, loader, ...tokens) => route => middleware(async () => {
    // TODO with target selector 
    const template = await loader?.();
    const enter = () => {
        DEBUG: route.VERBOSE && console.debug(`voyager/config view "${name}" enter`);
        // TODO with target selector callback here to e.g. create $scope and $compile
        setViewPort(name, template, ...[...classList(template), ...tokens]);
        on(route, 'leave', () => {
            DEBUG: route.VERBOSE && console.debug(`voyager/config view "${name}" leave`);
            // TODO with target selector callback here to e.g $destroy $scope
            setViewPort(name, undefined);
        }, { once: true });
    };
    on(route, 'enter', enter, { once: true });
    on(rootRoute, 'settled', () => {
        DEBUG: route.VERBOSE && console.debug(`voyager/config view "${name}" settled`);
        off(route, 'enter', enter);
    }, { once: true });
})(route);
